/**
 * Shared utilities for report components.
 */

/**
 * Generate an array of numbers from start to stop with step.
 */
export function range(start: number, stop: number, step: number): number[] {
  return Array.from(
    { length: (stop - start) / step + 1 },
    (_, i) => start + i * step
  );
}

/**
 * Get the last N years for report year dropdowns (current year first).
 * @param count Number of years to return (default 5)
 */
export function getReportYears(count: number = 5): number[] {
  const currentYear = new Date().getFullYear();
  return range(currentYear, currentYear - count, -1);
}

/** Month keys used in month-based report columns */
export const REPORT_MONTH_KEYS = [
  'jan', 'feb', 'mar', 'apr', 'may', 'jun',
  'jul', 'aug', 'sep', 'oct', 'nov', 'dec',
] as const;

/** Number of week columns in week-based reports */
export const WEEK_COLUMN_COUNT = 52;
